function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
import { LEVEL1_LOADED } from '../actions/level1Actions';

/**
 * state of format
 * {
 *    [instrumentId]: {},
 *    [instrumentId]: {},
 *    ...
 * }
 */
var initialState = {};
export default function level1() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var _ref = arguments[1];
  var type = _ref.type,
    payload = _ref.payload;
  switch (type) {
    case LEVEL1_LOADED:
      return handleLevel1Loaded(state, payload);
    default:
      return state;
  }
}
function handleLevel1Loaded(state, _ref2) {
  var instrumentId = _ref2.instrumentId,
    level1Data = _ref2.level1Data;
  return Object.assign({}, state, _defineProperty({}, instrumentId, level1Data));
}